import React, { memo } from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { View } from 'react-native';
import {
  PreviewProfilePage,
  PreviewLinkPage,
  PreviewShopPage,
  PreviewGalleryPage,
  PreviewResumePage,
} from '@redlink/components/pages';
import { useLocale } from '@redlink/assets/locale';
import { useValues } from '@redlink/assets/values';
import {
  PreviewTabBar,
  PreviewTabBarVertical,
} from '@redlink/components/muscles';
import { DrawerIcon } from '@redlink/components/molecules';
import { isMobile } from 'react-device-detect';
import { CompatibleContainer } from './compatibleContainer';
import { createUseStyle } from '@redlink/assets/styles';

const PreviewTab = createBottomTabNavigator();

export const PreviewTabNavigator = memo(
  ({ defaultTab, visibleTabs = ['profile'], pageName }) => {
    const { dictionary } = useLocale();
    const { routes, staticData } = useValues();
    const { styles } = useStyle();

    const showTabBar = visibleTabs.length > 1;
    const tabIsVisible = (tab) => visibleTabs.some((p) => p === tab);

    return (
      <View style={styles.container}>
        <PreviewTab.Navigator
          screenOptions={{
            headerShown: false,
          }}
          initialRouteName={staticData.previewTabsRoutes[defaultTab]}
          tabBar={(props) =>
            !showTabBar ? null : isMobile ? (
              <PreviewTabBar {...props} />
            ) : (
              <PreviewTabBarVertical {...props} />
            )
          }
        >
          {tabIsVisible(staticData.previewTabsObject.profile) && (
            <PreviewTab.Screen
              name={routes.previewProfile.key}
              component={() => (
                <CompatibleContainer>
                  <PreviewProfilePage {...{ pageName }} />
                </CompatibleContainer>
              )}
              options={{
                tabBarLabel: dictionary.profile,
                tabBarIcon: (props) => (
                  <DrawerIcon name={routes.profile.name} {...props} />
                ),
              }}
            />
          )}
          {tabIsVisible(staticData.previewTabsObject.links) && (
            <PreviewTab.Screen
              name={routes.previewLink.key}
              component={() => (
                <CompatibleContainer>
                  <PreviewLinkPage {...{ pageName }} />
                </CompatibleContainer>
              )}
              options={{
                tabBarLabel: dictionary.links,
                tabBarIcon: (props) => (
                  <DrawerIcon name={routes.link.name} {...props} />
                ),
              }}
            />
          )}
          {tabIsVisible(staticData.previewTabsObject.shop) && (
            <PreviewTab.Screen
              name={routes.previewShop.key}
              component={() => (
                <CompatibleContainer>
                  <PreviewShopPage {...{ pageName }} />
                </CompatibleContainer>
              )}
              options={{
                tabBarLabel: dictionary.shop,
                tabBarIcon: (props) => (
                  <DrawerIcon name={routes.shop.name} {...props} />
                ),
              }}
            />
          )}
          {tabIsVisible(staticData.previewTabsObject.gallery) && (
            <PreviewTab.Screen
              name={routes.previewGallery.key}
              component={() => (
                <CompatibleContainer>
                  <PreviewGalleryPage {...{ pageName }} />
                </CompatibleContainer>
              )}
              options={{
                tabBarLabel: dictionary.gallery,
                tabBarIcon: (props) => (
                  <DrawerIcon name={routes.gallery.name} {...props} />
                ),
              }}
            />
          )}
          {tabIsVisible(staticData.previewTabsObject.resume) && (
            <PreviewTab.Screen
              name={routes.previewResume.key}
              component={() => (
                <CompatibleContainer>
                  <PreviewResumePage {...{ pageName }} />
                </CompatibleContainer>
              )}
              options={{
                tabBarLabel: dictionary.resume,
                tabBarIcon: (props) => (
                  <DrawerIcon name={routes.resume.name} {...props} />
                ),
              }}
            />
          )}
        </PreviewTab.Navigator>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, width }) => ({
  container: {
    flex: 1,
    backgroundColor: colors.red1,
  },
}));
